import { useGet } from '../../../../api';
import {IncidentsConfiguration} from "../../IncidentsConfiguration/types";

const ENDPOINT = '/incidents/configurations';

const useGetIncidentsConfigurations = () => {
    const { data, fetchData, error, loading } = useGet<IncidentsConfiguration[]>({
        url: ENDPOINT
    });
    return { incidentsConfiguration: data, isFetching: loading, error, refetch: fetchData };
};

export default useGetIncidentsConfigurations;
